/**
 * @import internal modules
 */

/**
 * @import external modules
 */

import * as React from 'react';
import { pure } from 'recompose';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import * as URL from '@apps-enums/index';

// component
const Component: React.FunctionComponent<any> = (
    props: InterfaceMenu<string>,
): JSX.Element => {
    const {
        classnames,
        menuactive,
        onMenuClick,
        hideShowmenu,
        onLogout,
    } = props;

    return (
        <div className={classnames}>
            <div className="menu-tabs" id="menu-burger" onClick={hideShowmenu}>
                <div />
                <div />
                <div />
            </div>
            <section className="navigationMenu">
                <div
                    className={cx('menuText', { 'active-menu': menuactive[0] })}
                    onClick={onMenuClick(0)}>
                    <Link to={URL.EnumUrl.REALTIME}>
                        <div className="separator" />
                        <div className="icons-menu left ">
                            <svg viewBox="0 0 460 460">
                                <defs>
                                    <linearGradient
                                        id="grad1"
                                        x1="0%"
                                        y1="0%"
                                        x2="100%"
                                        y2="0%">
                                        <stop
                                            offset="0%"
                                            style={{
                                                stopColor: '#6A11CB',
                                                stopOpacity: 1,
                                            }}
                                        />
                                        <stop
                                            offset="100%"
                                            style={{
                                                stopColor: '#2575FC',
                                                stopOpacity: 1,
                                            }}
                                        />
                                    </linearGradient>
                                </defs>

                                <g>
                                    <path
                                        fill="url(#grad1)"
                                        d="M210,21c104.216,0,189,84.784,189,189s-84.784,189-189,189S21,314.216,21,210S105.784,21,210,21 M210,0
		C94.031,0,0,94.024,0,210s94.031,210,210,210s210-94.024,210-210S325.969,0,210,0L210,0z"
                                    />
                                    <path
                                        fill="url(#grad1)"
                                        d="M293.909,187.215l-111.818-73.591C162.792,100.926,147,109.445,147,132.545V287.42c0,23.1,15.813,31.647,35.147,18.998
		L293.86,233.31C313.187,220.647,313.208,199.913,293.909,187.215z M279.006,217.868l-99.295,64.981
		c-6.44,4.221-11.711,1.372-11.711-6.328V143.437c0-7.7,5.264-10.535,11.697-6.3l99.33,65.366
		C285.46,206.731,285.453,213.647,279.006,217.868z"
                                    />
                                </g>
                                <g />
                                <g />
                                <g />
                                <g />
                                <g />
                                <g />
                                <g />
                                <g />
                                <g />
                                <g />
                                <g />
                                <g />
                                <g />
                                <g />
                                <g />
                            </svg>
                        </div>
                        <p className="text-menu left">Real time</p>
                    </Link>
                </div>
                <div
                    className={cx('menuText', { 'active-menu': menuactive[1] })}
                    onClick={onMenuClick(1)}>
                    <Link to={URL.EnumUrl.DELAYED}>
                        <div className="separator" />
                        <div className="icons-menu left ">
                            <svg
                                viewBox="0 0 129 129"
                                enable-background="new 0 0 129 129">
                                <defs>
                                    <linearGradient
                                        id="grad1"
                                        x1="0%"
                                        y1="0%"
                                        x2="100%"
                                        y2="0%">
                                        <stop
                                            offset="0%"
                                            style={{
                                                stopColor: '#6A11CB',
                                                stopOpacity: 1,
                                            }}
                                        />
                                        <stop
                                            offset="100%"
                                            style={{
                                                stopColor: '#2575FC',
                                                stopOpacity: 1,
                                            }}
                                        />
                                    </linearGradient>
                                </defs>

                                <g>
                                    <g>
                                        <path
                                            fill="url(#grad1)"
                                            d="m12.3,70.2c0,28.8 23.4,52.2 52.2,52.2s52.2-23.4 52.2-52.2c0-14.3-5.8-27.4-15.2-36.8l4.1-4.1 1.9,1.9c0.8,0.8 1.8,1.2 2.9,1.2s2.1-0.4 2.9-1.2c1.6-1.6 1.6-4.2 0-5.8l-9.5-9.5c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l1.9,1.9-4.5,4.5c-7.6-5.6-16.7-9.1-26.7-9.9v-3.5h9.1c2.3,0 4.1-1.8 4.1-4.1s-1.8-4.1-4.1-4.1h-27c-2.3,0-4.1,1.8-4.1,4.1s1.8,4.1 4.1,4.1h9.7v3.5c-27,2.1-48.2,24.6-48.2,52zm52.2-44c24.3-3.55271e-15 44.1,19.8 44.1,44.1 0,24.3-19.8,44.1-44.1,44.1-24.3,0-44.1-19.8-44.1-44.1 0-24.4 19.8-44.1 44.1-44.1z"
                                        />
                                        <path
                                            fill="url(#grad1)"
                                            d="m64.5,73.6h17.5c2.3,0 4.1-1.8 4.1-4.1 0-2.3-1.8-4.1-4.1-4.1h-13.4v-21.1c0-2.3-1.8-4.1-4.1-4.1-2.3,0-4.1,1.8-4.1,4.1v25.3c0,2.2 1.8,4 4.1,4z"
                                        />
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <p className="text-menu left">Delayed</p>
                    </Link>
                </div>
            </section>
            <section className="deconnexion">
                <div className="deconnexion-insider">
                    <span onClick={onLogout}>Logout</span>
                </div>
            </section>
        </div>
    );
};
// interface
export interface InterfaceMenu<T> {
    classnames: T;
    menuactive?: any;
    onMenuClick?: any;
    hideShowmenu?: any;
    onLogout?: any;
}

export default pure(Component);



// WEBPACK FOOTER //
// ./src/apps/components/@shared/menu/component.tsx